// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Swiper from "swiper";
import Classnames from "classnames";
import * as Css_Js_Core from "bs-css/src/Css_Js_Core.bs.js";
import * as Core from "swiper/core";
import * as React from "swiper/react";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

import 'swiper/swiper-bundle.min.css'
;

var carousel = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.selector("a", [
            BsCssJs$PrezzeeRibbon.textDecoration("none"),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.flex3(0, 0, BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.display("flex")
          ])]);

function pagination(theme) {
  var match = theme.components;
  var fullWidthCarousel = match.fullWidthCarousel;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.display("flex"),
              BsCssJs$PrezzeeRibbon.justifyContent("center"),
              BsCssJs$PrezzeeRibbon.flexWrap("wrap"),
              BsCssJs$PrezzeeRibbon.width("auto"),
              BsCssJs$PrezzeeRibbon.left("auto"),
              BsCssJs$PrezzeeRibbon.right("auto"),
              BsCssJs$PrezzeeRibbon.bottom("auto"),
              BsCssJs$PrezzeeRibbon.top("auto"),
              BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
              BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.position("relative")),
              BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(18)),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSmUp, [BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(30))]),
              BsCssJs$PrezzeeRibbon.selector(".swiper-pagination-bullet", [
                    BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(12)),
                    BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(12)),
                    BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.pct(50)),
                    BsCssJs$PrezzeeRibbon.borderWidth(BsCssJs$PrezzeeRibbon.px(1)),
                    BsCssJs$PrezzeeRibbon.borderStyle("solid"),
                    BsCssJs$PrezzeeRibbon.borderColor(Theme__Color$PrezzeeRibbon.white),
                    BsCssJs$PrezzeeRibbon.backgroundColor(fullWidthCarousel.paginationColour),
                    BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.px(6)),
                    BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
                    BsCssJs$PrezzeeRibbon.opacity(1)
                  ]),
              BsCssJs$PrezzeeRibbon.selector(".swiper-pagination-bullet.swiper-pagination-bullet-active", [
                    BsCssJs$PrezzeeRibbon.backgroundColor(fullWidthCarousel.activePaginationColour),
                    BsCssJs$PrezzeeRibbon.boxShadow(Css_Js_Core.Shadow.box(BsCssJs$PrezzeeRibbon.px(0), BsCssJs$PrezzeeRibbon.px(0), BsCssJs$PrezzeeRibbon.px(0), BsCssJs$PrezzeeRibbon.px(1), undefined, fullWidthCarousel.activePaginationColour))
                  ])
            ]);
}

var Styles = {
  carousel: carousel,
  pagination: pagination
};

function FullWidthCarousel(props) {
  var className = props.className;
  var autoplay = props.autoplay;
  var showPagination = props.showPagination;
  var showPagination$1 = showPagination !== undefined ? showPagination : true;
  var autoplay$1 = autoplay !== undefined ? autoplay : false;
  var className$1 = className !== undefined ? className : "";
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  Curry._1(Core.Swiper.use, [
        Swiper.Pagination,
        Swiper.Autoplay
      ]);
  var swiperAutoplay = {
    enabled: autoplay$1,
    delay: 5000,
    disableOnInteraction: true
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(React.Swiper, {
                      autoplay: swiperAutoplay,
                      children: props.children,
                      pagination: {
                        el: ".swiper-pagination",
                        type: "bullets",
                        dynamicBullets: false,
                        dynamicMainBullets: 1,
                        clickable: true
                      }
                    }),
                showPagination$1 ? JsxRuntime.jsx("div", {
                        className: Classnames([
                              "swiper-pagination",
                              pagination(theme)
                            ])
                      }) : null
              ],
              className: Classnames([
                    carousel,
                    className$1
                  ])
            });
}

var Slide;

var SwiperCore;

var SwiperPagination;

var SwiperAutoplay;

var make = FullWidthCarousel;

export {
  Slide ,
  SwiperCore ,
  SwiperPagination ,
  SwiperAutoplay ,
  Styles ,
  make ,
}
/*  Not a pure module */
